import { URL_API } from "../../../general/init/url";

export const API_LOGIN = "/api/login";
export const API_LOGOUT = "/api/logout";
export const API_USER_INFO_BASIC = URL_API + "/api/profile";
export const API_USER_CHANGE_PASS = URL_API + "/api/change-pass";
